import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import paymentHelper from "../../helper/paymentHelper";
import transactionItemHelper from "../../helper/transactionItemHelper";
import transactionHelper from "../../helper/transactionItemHelper.js";
import i18n from "../../locales/i18n";

function GetCreateAllocationTransaction(allocationTransacionRawList) {
  let allocationTransactionList = [];
  if (allocationTransacionRawList && allocationTransacionRawList.length > 0) {
    for (let allocationTransacionRaw of allocationTransacionRawList) {
      if (
        allocationTransacionRaw.allocationId &&
        allocationTransacionRaw.allocationItemList &&
        allocationTransacionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransacionRaw.allocationId,
          allocationItemList: [],
        };
        for (let allocationItemRaw of allocationTransacionRaw.allocationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationValue: allocationItemRaw.percent.ToNumber(),
              allocationValueType: allocationItemRaw.valueType,
              allocationPercent: allocationItemRaw.percent.ToNumber(),
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
}
function GetCreateAllocationTransactionItem(allocationTransacionItemRawList) {
  let allocationTransactionItemList = [];
  if (allocationTransacionItemRawList && allocationTransacionItemRawList.length > 0) {
    for (let allocationTransacionItemRaw of allocationTransacionItemRawList) {
      let allocationTransactionItem = {
        transactionItemId: allocationTransacionItemRaw.transactionItemId,
        allocationTransactionList: GetCreateAllocationTransaction(
          allocationTransacionItemRaw.allocationTransactionList
        ),
      };
      allocationTransactionItemList.push(allocationTransactionItem);
    }
  }
  return allocationTransactionItemList;
}
function GetExpenseTypeForGetSuggestionTransactionNumber(_transaction) {
  let expenseType = _transaction.expenseType;
  if (_transaction.expenseType === Enums.ExpenseType.PurchaseInventory) {
    expenseType = Enums.ExpenseType.Expense;
  } else if (_transaction.transactionItemType) {
    expenseType = _transaction.transactionItemType;
  }
  return expenseType;
}
function ConvertToTransactionDetail(_transaction) {
  let transactionDetailTemplate = {
    referenceName: _transaction.referenceName,
    id: _transaction.id,
    number: _transaction.number,
    uuid: _transaction.uuid,
    date: _transaction.date,
    dueDate: _transaction.dueDate ? _transaction.dueDate : null,
    actionDate: _transaction.actionDate,
    isVat: _transaction.isVat,
    isDeleted: _transaction.isDeleted,
    discount: _transaction.discount,
    discountType: _transaction.discountType,
    remark: _transaction.remark,
    transactionStatus: _transaction.transactionStatus,
    contactId: _transaction.contactId,
    contactCode: "",
    transactionType: _transaction.transactionType,
    financeType: _transaction.financeType,
    expenseType: _transaction.expenseType,
    transactionItemType: _transaction.transactionItemType,
    taxStatus: _transaction.taxStatus,
    userId: _transaction.userId,
    lockStatusId: _transaction.lockStatusId,
    transactionSummary: {
      preVatTotal: _transaction.transactionSummary.preVatTotal,
      zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
      vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
      taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
      vatTotal: _transaction.transactionSummary.vatTotal,
      subTotal: _transaction.transactionSummary.subTotal,
      netAmount: _transaction.transactionSummary.netAmount,
      subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
      whtTotal: _transaction.transactionSummary.whtTotal,
      remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
      remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
      isAllNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
      isServiceOnly: _transaction.transactionSummary.isServiceOnly,
      sameProductVatType: _transaction.transactionSummary.sameProductVatType,
    },
    transactionCurrency: {
      fromCurrencyUid: _transaction.transactionCurrency.fromCurrencyUid,
      toCurrencyUid: _transaction.transactionCurrency.toCurrencyUid,
      fromCurrencyCode: _transaction.transactionCurrency.fromCurrencyCode,
      toCurrencyCode: _transaction.transactionCurrency.toCurrencyCode,
      fromCurrencyCountryName: _transaction.transactionCurrency.fromCurrencyCountryName,
      toCurrencyCountryName: _transaction.transactionCurrency.toCurrencyCountryName,
      currencyExchangeRates: _transaction.transactionCurrency.currencyExchangeRates,
      currencyRatio: _transaction.transactionCurrency.currencyRatio,
      currencyPreVatTotal: _transaction.transactionCurrency.currencyPreVatTotal,
      currencyZeroVatTotal: _transaction.transactionCurrency.currencyZeroVatTotal,
      currencyVatExemptedTotal: _transaction.transactionCurrency.currencyVatExemptedTotal,
      currencyTaxExclusiveTotal: _transaction.transactionCurrency.currencyTaxExclusiveTotal,
      currencyVatTotal: _transaction.transactionCurrency.currencyVatTotal,
      currencySubTotal: _transaction.transactionCurrency.currencySubTotal,
      currencyNetAmount: _transaction.transactionCurrency.currencyNetAmount,
      currencySubTotalForCalculateWht: _transaction.transactionCurrency.currencySubTotalForCalculateWht,
      currencyWhtTotal: _transaction.transactionCurrency.currencyWhtTotal,
    },
    transactionItems: [],
    allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(_transaction.allocationTransactionList),
  };

  let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
    _transaction.taxStatus,
    _transaction.transactionItemList
  );

  let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
    transactionListForCalculateAllocateDiscountPercent,
    _transaction.discount,
    _transaction.discountType,
    _transaction.taxStatus
  );

  if (_transaction.transactionItemList && _transaction.transactionItemList.length > 0) {
    _transaction.transactionItemList.forEach((transactionItems) => {
      let transactionItemsTemplate = {
        id: transactionItems.id,
        productTemplateId: transactionItems.productTemplateId,
        assetId: transactionItems.assetId,
        description: transactionItems.description,
        price: transactionItems.price,
        amount: transactionItems.amount,
        discount: transactionItems.discount,
        vatType: transactionItems.vatType,
        discountType: transactionItems.discountType,
        netAmount: transactionItems.netAmount,
        productTemplateCode: transactionItems.productTemplateId > 0 ? transactionItems.code : "",
        productTemplateName: "",
        stockactivityId: transactionItems.stockactivityId,
        accountId: transactionItems.accountId,
        accountCode: transactionItems.accountCode,
        accountName: transactionItems.accountName,
        accountNameEng: transactionItems.accountNameEng,
        productTemplateUuid: transactionItems.productTemplateUuid,
        uuid: transactionItems.uuid,
        isDescriptionOnly: transactionItems.isDescriptionOnly,
        accountRefId: transactionItems.accountRefId,
        accountRefTypeId: transactionItems.accountRefTypeId,
        refTransactionProductId: transactionItems.refTransactionProductId,
        refStockActivityId: transactionItems.refStockActivityId,
        creditNoteRefTransactionId: transactionItems.creditNoteRefTransactionId,
        refTransactionTypeId: transactionItems.refTransactionTypeId,
        pp30TransactionProductId: transactionItems.pp30TransactionProductId,
        isPP30Checked: transactionItems.isPP30Checked,
        isPP30Created: transactionItems.isPP30Created,
        billedAmount: transactionItems.billedAmount,
        vatAmount: transactionItems.vatAmount,
        fixAssetTemplateId: transactionItems.fixAssetTemplateId
          ? transactionItems.fixAssetTemplateId
          : transactionItems.assetTemplateId,
        isAcquisitionCost: transactionItems.isAcquisitionCost ? true : false,
        fixAssetTemplateCode: transactionItems.code,
        whtPercent: transactionItems.whtPercent,
        whtAmount: transactionItems.whtAmount,
        whtAmountType: transactionItems.whtAmountType,
        taxIncomeTypeId: transactionItems.taxIncomeTypeId,
        subTotal: transactionItems.subTotal,
        sequenceNumber: transactionItems.sequenceNumber,
        unitId: transactionItems.unitId,
        unitName: i18n.locale == Enums.LanguageType.Thai ? transactionItems.unitNameTh : transactionItems.unitNameEng,
        isUseTransactionAllocation: true,
        itemNetAmountWithAllocateDiscountForAllocation: 0,
        itemNetAmountWithAllocateDiscountTotal: 0,
        allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
          transactionItems.allocationTransactionList
        ),
      };
      if (transactionItemsTemplate.allocationList && transactionItemsTemplate.allocationList.length > 0) {
        let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
          transactionDetailTemplate.allocationList,
          transactionItemsTemplate.allocationList
        );
        transactionItemsTemplate.isUseTransactionAllocation = allocationTransactionEquals;
      }

      let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
        transactionItems
      );
      let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
        transactionItemForCalculateProductTotalPrice,
        allocateDiscountPercent,
        _transaction.transactionCurrency.toCurrencyUid,
        _transaction.transactionCurrency.currencyExchangeRates,
        _transaction.transactionCurrency.currencyRatio,
        _transaction.taxStatus,
        _transaction.isCreatedTaxInvoice,
        _transaction.transactionType,
        _transaction.financeType,
        false
      );

      transactionItemsTemplate.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
      transactionItemsTemplate.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

      transactionDetailTemplate.transactionItems.push(transactionItemsTemplate);
    });
  }

  return transactionDetailTemplate;
}

function CovertToBillingNoteTransaction(billingNoteDetailItemList) {
  let billingNoteTransactionList = [];
  if (billingNoteDetailItemList && billingNoteDetailItemList.length > 0) {
    billingNoteDetailItemList.forEach((billingNoteDetailItem) => {
      let billingNoteTransaction = {
        id: billingNoteDetailItem.invoiceId,
        billedAmount: billingNoteDetailItem.billedAmount,
        billedIsNoneOrNotSpecifyWht: billingNoteDetailItem.isAllNoneOrNotSpecifyWht,
        invoiceDate: billingNoteDetailItem.invoiceDate,
        invoiceDueDate: billingNoteDetailItem.invoiceDueDate,
        invoiceId: billingNoteDetailItem.invoiceId,
        invoiceNetAmount: billingNoteDetailItem.invoiceNetAmount,
        invoiceNumber: billingNoteDetailItem.invoiceNumber,
        billedWht:
          billingNoteDetailItem.toCurrencyUid == Enums.CurrencyCode.THB
            ? billingNoteDetailItem.whtAmount
            : (
                billingNoteDetailItem.whtAmount / billingNoteDetailItem.currencyModel.currencyExchangeRates
              ).ToAccountingRoundUpNumber(),
        creditNoteList: [],
        referenceTransactionId: billingNoteDetailItem.invoiceId,
        referenceTransactionTypeId: Enums.TransactionType.Invoice,
        currencyBilledAmount: billingNoteDetailItem.currencyBilledAmount,
        currencyModel: billingNoteDetailItem.currencyModel,

        invoiceVatExemptedTotal: billingNoteDetailItem.vatExemptedTotal,
        invoiceZeroVatTotal: billingNoteDetailItem.invoiceZeroVatTotal,
        invoicePreVatTotal: billingNoteDetailItem.invoicePreVatTotal,
        invoiceVatTotal: billingNoteDetailItem.invoiceVatTotal,
        invoiceSubTotalForCalculateWht: billingNoteDetailItem.invoiceSubTotalForCalculateWht,
        invoiceWithCreditNoteNetAmount: billingNoteDetailItem.invoiceWithCreditNoteNetAmount,

        remainPaymentAmount: billingNoteDetailItem.remainPaymentAmount,
        remainCurrencyPaymentNetAmount: billingNoteDetailItem.remainCurrencyPaymentNetAmount,
        remainWhtPaymentNetAmount: billingNoteDetailItem.remainWhtPaymentNetAmount,

        invoiceCurrencyVatExemptedTotal: billingNoteDetailItem.currencyModel.currencyVatExemptedTotal,
        invoiceCurrencyZeroVatTotal: billingNoteDetailItem.currencyModel.currencyZeroVatTotal,
        invoiceCurrencyPreVatTotal: billingNoteDetailItem.currencyModel.currencyPreVatTotal,
        invoiceCurrencySubTotalForCalculateWht: billingNoteDetailItem.currencyModel.currencySubTotalForCalculateWht,
        invoiceCurrencyVatTotal: billingNoteDetailItem.currencyModel.currencyVatTotal,
        invoiceCurrencyWithCreditNoteNetAmount: billingNoteDetailItem.invoiceCurrencyWithCreditNoteNetAmount,
        invoiceCurrencyExchangeRates: billingNoteDetailItem.currencyModel.currencyExchangeRates,
        fromCurrencyUid: billingNoteDetailItem.currencyModel.fromCurrencyUid,
        toCurrencyUid: billingNoteDetailItem.currencyModel.toCurrencyUid,
        billedVatTotal: billingNoteDetailItem.vatTotal,
        billedPreVatTotal: billingNoteDetailItem.preVatTotal,
        billedZeroVatTotal: billingNoteDetailItem.zeroVatTotal,
        billedVatExempted: billingNoteDetailItem.vatExemptedTotal,
        invoiceWhtTotal: billingNoteDetailItem.whtAmount,
        whtAmount: billingNoteDetailItem.whtAmount,
        billedSubTotalForCalculateWht: billingNoteDetailItem.subTotalForCalculateWht,
        billedInvoiceSameVatTypeProduct: billingNoteDetailItem.sameProductVatType,
        billedIsInvoiceServiceOnly: billingNoteDetailItem.isServiceOnly,
        isServiceOnly: billingNoteDetailItem.isServiceOnly,
        isNoneOrNotSpecifyWht: billingNoteDetailItem.isAllNoneOrNotSpecifyWht,
        sameProductVatType: billingNoteDetailItem.sameProductVatType,
      };
      if (billingNoteDetailItem.creditNoteList && billingNoteDetailItem.creditNoteList.length > 0) {
        billingNoteDetailItem.creditNoteList.forEach((creditNote) => {
          billingNoteTransaction.creditNoteList.push({
            id: creditNote.id,
            isAllNoneOrNotSpecifyWht: creditNote.isAllNoneOrNotSpecifyWht,
            creditNoteAmount: creditNote.creditNoteAmount,
            transactionDate: new Date(creditNote.transactionDate).GetDateFormat(),
            transactionId: creditNote.transactionId,
            transactionNetAmount: creditNote.transactionNetAmount,
            transactionNumber: creditNote.transactionNumber,
            whtAmount: creditNote.whtAmount,
          });
        });
      }
      billingNoteTransactionList.push(billingNoteTransaction);
    });
    return billingNoteTransactionList;
  }
}

function ConvertPaymentFromPaymentModel(paymentRaw, paymentDisabled) {
  let payment = paymentHelper.GetCreateTransactionPaymentDefualt();
  if (paymentRaw && paymentRaw.paymentGroupList && paymentRaw.paymentGroupList.length > 0) {
    payment.paymentGroupList = [];
    payment.disabled = paymentDisabled;
    for (let paymentGroupRaw of paymentRaw.paymentGroupList) {
      let paymentGroupDefault = paymentHelper.GetCreateTransactionPaymentGroupDefualt();
      paymentGroupDefault.disabled = paymentDisabled;
      if (
        paymentGroupRaw.paymentTransactionBankAccountList &&
        paymentGroupRaw.paymentTransactionBankAccountList.length > 0
      ) {
        paymentGroupDefault.paymentTransactionBankAccountList = [];
        let count = 0;
        for (let paymentBankAccountTransactionRaw of paymentGroupRaw.paymentTransactionBankAccountList) {
          count++;
          if (count > 1) {
            paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;
            paymentGroupDefault.paymentTransactionChartAccountHidden = false;
          }
          let paymentBankAccountTransaction = paymentHelper.GetCreatePaymentTransactionBankAccountDefault();
          paymentBankAccountTransaction.bankAccountId = paymentBankAccountTransactionRaw.bankAccountId;
          paymentBankAccountTransaction.paymentAmount = paymentBankAccountTransactionRaw.paymentAmount.FormatMoney();
          paymentBankAccountTransaction.remark = paymentBankAccountTransactionRaw.remark;
          paymentBankAccountTransaction.isCheque = paymentBankAccountTransactionRaw.cheque
            ? paymentBankAccountTransactionRaw.cheque.id > 0
            : false;
          if (paymentBankAccountTransaction.isCheque) {
            paymentBankAccountTransaction.cheque.id = paymentBankAccountTransactionRaw.cheque.id;
            paymentBankAccountTransaction.cheque.chequeDate = paymentBankAccountTransactionRaw.cheque.chequeDate;
            paymentBankAccountTransaction.cheque.branchNumber = paymentBankAccountTransactionRaw.cheque.branchNumber;
            paymentBankAccountTransaction.cheque.accountNumber = paymentBankAccountTransactionRaw.cheque.accountNumber;
            paymentBankAccountTransaction.cheque.chequeBankId = paymentBankAccountTransactionRaw.cheque.chequeBankId;
            paymentBankAccountTransaction.cheque.chequeNumber = paymentBankAccountTransactionRaw.cheque.chequeNumber;
          }
          paymentGroupDefault.paymentTransactionBankAccountList.push(paymentBankAccountTransaction);
        }
      }
      if (
        paymentGroupRaw.paymentTransactionChartOfAccountList &&
        paymentGroupRaw.paymentTransactionChartOfAccountList.length > 0
      ) {
        paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;
        paymentGroupDefault.paymentTransactionChartAccountHidden = false;
        paymentGroupDefault.paymentTransactionChartAccountActived = true;
        paymentGroupDefault.paymentTransactionChartOfAccountList = [];
        for (let paymentTransactionChartAccountRaw of paymentGroupRaw.paymentTransactionChartOfAccountList) {
          let paymentTransactionChartAccount = paymentHelper.GetCreatePaymentTransactionChartAccountDefault();
          paymentTransactionChartAccount.accountId = paymentTransactionChartAccountRaw.accountId;
          paymentTransactionChartAccount.remark = paymentTransactionChartAccountRaw.remark;

          if (paymentTransactionChartAccountRaw.paymentAmount < 0) {
            paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.WithDrawalAccount;
            paymentTransactionChartAccount.paymentAmount = (
              paymentTransactionChartAccountRaw.paymentAmount * -1
            ).FormatMoney();
          } else {
            paymentTransactionChartAccount.paymentAmount = paymentTransactionChartAccountRaw.paymentAmount.FormatMoney();
            paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.DepositeAccount;
          }
          paymentGroupDefault.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
        }
      }
      if (paymentGroupRaw.paymentTransactionDocumentList && paymentGroupRaw.paymentTransactionDocumentList.length > 0) {
        paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;
        paymentGroupDefault.paymentTransactionDocumentHidden = false;
        paymentGroupDefault.paymentTransactionDocumentActived = true;
        paymentGroupDefault.paymentTransactionDocumentList = [];
        for (let paymentTransactionDocumentRaw of paymentGroupRaw.paymentTransactionDocumentList) {
          let paymentTransactionDocument = paymentHelper.GetCreatePaymentTransactionDocumentDefault();
          paymentTransactionDocument.transactionType = {
            value: paymentTransactionDocumentRaw.referenceTransactionType,
          };
          paymentTransactionDocument.transactionId = paymentTransactionDocumentRaw.referenceTransactionId;
          paymentTransactionDocument.transactionNumber = paymentTransactionDocumentRaw.referenceTransactionNumber;
          paymentTransactionDocument.paymentAmount = paymentTransactionDocumentRaw.paymentAmount.FormatMoney();
          paymentTransactionDocument.remark = paymentTransactionDocumentRaw.remark;

          paymentGroupDefault.paymentTransactionDocumentList.push(paymentTransactionDocument);
        }
      }
      paymentGroupDefault.whtPayment = {
        isWht: paymentGroupRaw.whtPayment.isWht,
        pndTypeId: paymentGroupRaw.whtPayment.pndType,
        whtAmountTypeId: paymentGroupRaw.whtPayment.whtAmountType,
        whtAmount: paymentGroupRaw.whtPayment.whtAmount.ToNumber().FormatMoney(),
        whtDeductType: paymentGroupRaw.whtPayment.whtDeductType,
        disabled: payment.disabled,
        hidden: false,
      };
      paymentGroupDefault.paymentGroupDate = paymentGroupRaw.paymentGroupDate;
      payment.paymentGroupList.push(paymentGroupDefault);
    }
  }
  return payment;
}
function ConvertPaymentForCreate(paymentRaw) {
  let payment = {
    paymentGroupList: [],
  };
  if (paymentRaw.paymentGroupList) {
    for (let paymentGroup of paymentRaw.paymentGroupList) {
      let _paymentGroup = {
        isPaymentActive: paymentGroup.isPaymentActive,
        paymentTransactionBankAccountList: [],
        paymentTransactionChartOfAccountList: [],
        paymentTransactionDocumentList: [],

        whtPayment: {
          isWht: paymentGroup.whtPayment.isWht,
          whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
          whtAmount: paymentGroup.whtPayment.whtAmount,
          pndType: paymentGroup.whtPayment.pndTypeId,
          whtDeductType: paymentGroup.whtPayment.whtDeductType,
        },
        paymentGroupDate: paymentGroup.paymentGroupDate,
      };
      if (_paymentGroup.isPaymentActive) {
        if (
          paymentGroup.paymentTransactionBankAccountList &&
          paymentGroup.paymentTransactionBankAccountList.length > 0
        ) {
          for (let paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
            let _paymentTransactionBankAccount = {
              bankAccountId: paymentTransactionBankAccount.bankAccountId,
              bankAccountCode: paymentTransactionBankAccount.bankAccountCode,
              isCheque: paymentTransactionBankAccount.isCheque,
              cheque: paymentTransactionBankAccount.isCheque
                ? {
                    chequeNumber: paymentTransactionBankAccount.cheque.chequeNumber,
                    chequeDate: paymentTransactionBankAccount.cheque.chequeDate,
                    branchNumber: paymentTransactionBankAccount.cheque.branchNumber,
                    accountNumber: paymentTransactionBankAccount.cheque.accountNumber,
                    chequeBankId: paymentTransactionBankAccount.cheque.chequeBankId,
                    createPaymentDate: paymentTransactionBankAccount.cheque.createPaymentDate,
                  }
                : {},
              paymentAmount: paymentTransactionBankAccount.paymentAmount,
              remark: paymentTransactionBankAccount.remark,
            };
            _paymentGroup.paymentTransactionBankAccountList.push(_paymentTransactionBankAccount);
          }
        }
        if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
          for (let paymentTransactionChartAccount of paymentGroup.paymentTransactionChartOfAccountList) {
            let _paymentTransactionChartAccount = {
              accountId: paymentTransactionChartAccount.accountId,
              accountCode: paymentTransactionChartAccount.accountCode,
              paymentAmount:
                (paymentTransactionChartAccount.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount ? -1 : 1) *
                paymentTransactionChartAccount.paymentAmount.ToNumber(),
              remark: paymentTransactionChartAccount.remark,
            };
            _paymentGroup.paymentTransactionChartOfAccountList.push(_paymentTransactionChartAccount);
          }
        }
        if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
          for (let paymentTransactionDocument of paymentGroup.paymentTransactionDocumentList) {
            let _paymentTransactionDocument = {
              referenceTransactionId: paymentTransactionDocument.transactionId,
              referenceTransactionType: paymentTransactionDocument.transactionType.value,
              referenceTransactionNumber: paymentTransactionDocument.transactionNumber,
              paymentAmount: paymentTransactionDocument.paymentAmount,
              paymentInOutFlowType: paymentTransactionDocument.paymentInOutFlowType,
              remark: paymentTransactionDocument.remark,
            };
            _paymentGroup.paymentTransactionDocumentList.push(_paymentTransactionDocument);
          }
        }
      }
      payment.paymentGroupList.push(_paymentGroup);
    }
  }
  return payment;
}
function ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType) {
  let payment = {
    transactionId: transactionId,
    transactionType: transactionType,
    paymentGroupList: [],
  };
  if (paymentRaw.paymentGroupList) {
    for (let paymentGroup of paymentRaw.paymentGroupList) {
      let _paymentGroup = {
        id: paymentGroup.id,
        paymentTransactionBankAccountList: [],
        paymentTransactionChartOfAccountList: [],
        paymentTransactionDocumentList: [],
        whtPayment: {
          id: paymentGroup.whtPayment.id,
          isWht: paymentGroup.whtPayment.isWht,
          whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
          whtAmount: paymentGroup.whtPayment.whtAmount,
          pndType: paymentGroup.whtPayment.pndType,
          pndId: paymentGroup.whtPayment.pndId,
          isFiledFromPeakTax: paymentGroup.whtPayment.isFiledFromPeakTax,
          isFetchedDataToPeakTax: paymentGroup.whtPayment.isFetchedDataToPeakTax,
        },
        paymentGroupDate: paymentGroup.paymentGroupDate,
        isApproved: paymentGroup.isApproved,
        transactionId: paymentGroup.transactionId,
        transactionType: paymentGroup.transactionType,
        transactionNumber: paymentGroup.transactionNumber,
        referenceTransactionId: paymentGroup.referenceTransactionId,
        referenceTransactionType: paymentGroup.referenceTransactionType,
        referenceTransactionNumber: paymentGroup.referenceTransactionNumber,
        referenceJournalList: [],
        paymentGroupTotal: 0,
        totalPaidPaymentWithOutChartOfAccount: 0,
      };
      _paymentGroup.totalPaidPaymentWithOutChartOfAccount += paymentGroup.whtPayment.whtAmount;
      if (paymentGroup.referenceJournalList && paymentGroup.referenceJournalList.length > 0) {
        for (let referenceJournal of paymentGroup.referenceJournalList) {
          _paymentGroup.referenceJournalList.push({
            isReconciled: referenceJournal.isReconciled,
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
        for (let paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
          let _paymentTransactionBankAccount = {
            id: paymentTransactionBankAccount.id,
            bankAccountId: paymentTransactionBankAccount.bankAccountId,
            bankAccountCode: paymentTransactionBankAccount.bankAccountCode,
            isCheque: paymentTransactionBankAccount.isCheque,
            cheque: paymentTransactionBankAccount.isCheque
              ? {
                  chequeId: paymentTransactionBankAccount.cheque.id,
                }
              : {},
            paymentAmount: paymentTransactionBankAccount.paymentAmount,
            remark: paymentTransactionBankAccount.remark,
          };
          _paymentGroup.totalPaidPaymentWithOutChartOfAccount += _paymentTransactionBankAccount.paymentAmount;
          _paymentGroup.paymentTransactionBankAccountList.push(_paymentTransactionBankAccount);
        }
      }
      if (
        paymentGroup.paymentTransactionChartOfAccountList &&
        paymentGroup.paymentTransactionChartOfAccountList.length > 0
      ) {
        for (let paymentTransactionChartAccount of paymentGroup.paymentTransactionChartOfAccountList) {
          let _paymentTransactionChartAccount = {
            id: paymentTransactionChartAccount.id,
            accountId: paymentTransactionChartAccount.accountId,
            accountCode: paymentTransactionChartAccount.accountCode,
            paymentAmount: paymentTransactionChartAccount.paymentAmount.ToNumber(),
            remark: paymentTransactionChartAccount.remark,
          };
          _paymentGroup.paymentGroupTotal += _paymentTransactionChartAccount.paymentAmount;
          _paymentGroup.paymentTransactionChartOfAccountList.push(_paymentTransactionChartAccount);
        }
      }
      if (paymentGroup.paymentTransactionDocumentList && paymentGroup.paymentTransactionDocumentList.length > 0) {
        for (let paymentTransactionDocument of paymentGroup.paymentTransactionDocumentList) {
          let _paymentTransactionDocument = {
            transactionId: paymentTransactionDocument.referenceTransactionId,
            transactionType: paymentTransactionDocument.referenceTransactionType,
            transactionNumber: paymentTransactionDocument.referenceTransactionNumber,
            transactionFinanceType: paymentTransactionDocument.referenceFinanceType,
            transactionExpenseType: paymentTransactionDocument.referenceExpenseType,
            paymentAmount: paymentTransactionDocument.paymentAmount,
            remark: paymentTransactionDocument.remark,
          };
          _paymentGroup.paymentGroupTotal += _paymentTransactionDocument.paymentAmount;
          _paymentGroup.paymentTransactionDocumentList.push(_paymentTransactionDocument);
        }
      }

      _paymentGroup.paymentGroupTotal += _paymentGroup.totalPaidPaymentWithOutChartOfAccount;
      payment.paymentGroupList.push(_paymentGroup);
    }
  }
  return payment;
}
function ConvertToTransactionTimelineJournal(journalRawList) {
  let journalList = [];
  if (journalRawList) {
    for (let journalRaw of journalRawList) {
      journalList.push({
        journalId: journalRaw.journalId,
        journalNumber: journalRaw.journalNumber,
      });
    }
  }
  return journalList;
}
function ConvertToTransactionTimelineReceipt(receiptRawList) {
  let receiptList = [];
  if (receiptRawList) {
    for (let receiptRaw of receiptRawList) {
      receiptList.push({
        receiptId: receiptRaw.receiptId,
        receiptNumber: receiptRaw.receiptNumber,
        receiptIsCreatedTaxInvoice: receiptRaw.receiptIsCreatedTaxInvoice,
        taxInvoiceId: receiptRaw.taxInvoiceId,
        taxInvoiceNumber: receiptRaw.taxInvoiceNumber,
      });
    }
  }
  return receiptList;
}
function ConvertToTransactionTimelineReceiptWithJournal(receiptRawList) {
  let receiptList = [];
  if (receiptRawList) {
    for (let receiptRaw of receiptRawList) {
      receiptList.push({
        receiptId: receiptRaw.receiptId,
        receiptNumber: receiptRaw.receiptNumber,
        receiptIsCreatedTaxInvoice: receiptRaw.receiptIsCreatedTaxInvoice,
        receiptIssuedIsTaxDocument: receiptRaw.receiptIssuedIsTaxDocument,
        taxInvoiceId: receiptRaw.taxInvoiceId,
        taxInvoiceNumber: receiptRaw.taxInvoiceNumber,
        journalList: ConvertToTransactionTimelineJournal(receiptRaw.journalList),
      });
    }
  }
  return receiptList;
}
function ConvertToTransactionTimelineInvoiceBillingNote(billingNoteRawList) {
  let billingNoteList = [];
  if (billingNoteRawList) {
    for (let billingNoteRaw of billingNoteRawList) {
      let billingNote = {
        billingNoteId: billingNoteRaw.billingNoteId,
        billingNoteNumber: billingNoteRaw.billingNoteNumber,
        journalList: ConvertToTransactionTimelineJournal(billingNoteRaw.journalList),
        receiptList: ConvertToTransactionTimelineReceipt(billingNoteRaw.receiptList),
      };
      billingNoteList.push(billingNote);
    }
  }
  return billingNoteList;
}
function ConvertToTransactionTimelineCombinePaymentNote(combinePaymentNoteRawList) {
  let combinePaymentNoteList = [];
  if (combinePaymentNoteRawList) {
    for (let combinePaymentNoteRaw of combinePaymentNoteRawList) {
      let combinePaymentNote = {
        combinePaymentNoteId: combinePaymentNoteRaw.combinePaymentNoteId,
        combinePaymentNoteNumber: combinePaymentNoteRaw.combinePaymentNoteNumber,
        journalList: ConvertToTransactionTimelineJournal(combinePaymentNoteRaw.journalList),
      };
      combinePaymentNoteList.push(combinePaymentNote);
    }
  }
  return combinePaymentNoteList;
}
function ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList) {
  let receivedIssuedTaxInvoiceList = [];
  if (receivedIssuedTaxInvoiceRawList && receivedIssuedTaxInvoiceRawList.length > 0) {
    for (let receivedIssuedTaxInvoiceRaw of receivedIssuedTaxInvoiceRawList) {
      let receivedIssuedTaxInvoice = {
        referencedJournalList: [],
        id: receivedIssuedTaxInvoiceRaw.id,
        receivedTaxInvoiceNumber: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceDate,
        preVatTotal: receivedIssuedTaxInvoiceRaw.preVatTotal,
        vatTotal: receivedIssuedTaxInvoiceRaw.vatTotal,
        netAmount: receivedIssuedTaxInvoiceRaw.netAmount,
        eTaxInvoiceId: receivedIssuedTaxInvoiceRaw.etaxInvoiceId,
        taxInvoiceId: receivedIssuedTaxInvoiceRaw.taxInvoiceId,
        referenceTransactionType: receivedIssuedTaxInvoiceRaw.referenceTransactionType,
        referenceTransactionId: receivedIssuedTaxInvoiceRaw.referenceTransactionId,
        referencePaymentGroupId: receivedIssuedTaxInvoiceRaw.referencePaymentGroupId,
      };
      if (
        receivedIssuedTaxInvoiceRaw.referencedJournalList &&
        receivedIssuedTaxInvoiceRaw.referencedJournalList.length > 0
      ) {
        for (let referenceJournal of receivedIssuedTaxInvoiceRaw.referencedJournalList) {
          receivedIssuedTaxInvoice.referencedJournalList.push({
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      receivedIssuedTaxInvoiceList.push(receivedIssuedTaxInvoice);
    }
    return receivedIssuedTaxInvoiceList;
  }
}

function GetRemainWhtPaymentAmount(invoiceRemainWhtPaymentAmount) {
  var remainWhtPaymentAmount = 0;
  if (invoiceRemainWhtPaymentAmount > 0) {
    remainWhtPaymentAmount = invoiceRemainWhtPaymentAmount;
  }
  return remainWhtPaymentAmount;
}

function GetBilledAmountFullBilling(billedAmount, remainCurrencyPaymentNetAmount) {
  if (billedAmount.ToNumber() == remainCurrencyPaymentNetAmount.ToAccountingRoundUpNumber()) {
    return remainCurrencyPaymentNetAmount.ToNumber();
  } else {
    return billedAmount.ToNumber();
  }
}
function GetBilledNetAmountForCurrency(invoice, billedAmount) {
  if (invoice.billedAmount.ToNumber() == invoice.remainCurrencyPaymentNetAmount.ToAccountingRoundUpNumber()) {
    return invoice.remainPaymentAmount.ToNumber();
  } else {
    return billedAmount.ToNumber();
  }
}
function SetBillingNoteCESummerryAndCurrency(transactionCreate, result) {
  let totalBilledNetAmount = 0;
  let totalBilledVat = 0;
  let totalBilledPreVat = 0;
  let totalBilledZeroVat = 0;
  let totalBilledVatExempted = 0;
  let totalBilledSubTotalForCalculateWht = 0;
  let totalBilledWht = 0;
  let billingNoteIsNoneOrNotSpecifyWht = false;
  let billingNoteIsServiceOnly = true;
  let invoiceNetAmount = 0;

  let totalCurrencyBilledAmount = 0;
  let totalCurrencyBilledVat = 0;
  let totalCurrencyBilledPreVat = 0;
  let totalCurrencyBilledZeroVat = 0;
  let totalCurrencyBilledVatExempted = 0;
  let totalCurrencyBilledWht = 0;
  let totalCurrencyBilledSubTotalForCalculateWht = 0;
  result.forEach((item, index) => {
    let isThaiBaht = item.toCurrencyUid == Enums.CurrencyCode.THB;
    let remainWhtPaymentNetAmount = GetRemainWhtPaymentAmount(item.remainWhtPaymentNetAmount);
    let billedAmount = isThaiBaht
      ? item.billedAmount.ToNumber()
      : GetBilledAmountFullBilling(item.billedAmount, item.remainCurrencyPaymentNetAmount);
    let billedPercent =
      billedAmount / (isThaiBaht ? item.invoiceWithCreditNoteNetAmount : item.invoiceCurrencyWithCreditNoteNetAmount);
    let billedWhtPercent = billedAmount / item.remainCurrencyPaymentNetAmount;

    let billedWhtItem = isThaiBaht
      ? billedWhtPercent * remainWhtPaymentNetAmount.ToAccountingRoundUpNumber()
      : (
          (item.invoiceCurrencyExchangeRates * (billedWhtPercent * remainWhtPaymentNetAmount.ToNumber())) /
          item.invoiceCurrencyRatio
        ).ToAccountingRoundUpNumber();
    let billedVatExemptedTotal = (billedPercent * item.invoiceVatExemptedTotal.ToNumber()).ToAccountingRoundUpNumber();
    let billedZeroVatTotal = (billedPercent * item.invoiceZeroVatTotal.ToNumber()).ToAccountingRoundUpNumber();
    let billedPreVatTotal = (billedPercent * item.invoicePreVatTotal.ToNumber()).ToAccountingRoundUpNumber();
    let billedVatTotal = (billedPercent * item.invoiceVatTotal.ToNumber()).ToAccountingRoundUpNumber();
    let billedSubTotalForCalculateWht = (
      billedPercent * item.invoiceSubTotalForCalculateWht.ToNumber()
    ).ToAccountingRoundUpNumber();
    let billedAmountTotal = billedVatExemptedTotal + billedZeroVatTotal + billedPreVatTotal + billedVatTotal;
    let billedAmountItem = isThaiBaht
      ? item.billedAmount.ToNumber().ToAccountingRoundUpNumber()
      : GetBilledNetAmountForCurrency(item, billedAmountTotal).ToAccountingRoundUpNumber();
    let currencyBilledAmount = item.billedAmount.ToAccountingRoundUpNumber();
    let currencyBilledWht = (billedWhtPercent * item.remainWhtPaymentNetAmount.ToNumber()).ToAccountingRoundUpNumber();
    let currencyBilledVatExemptedTotal = (
      billedPercent * item.invoiceCurrencyVatExemptedTotal.ToNumber()
    ).ToAccountingRoundUpNumber();
    let currencyBilledZeroVatTotal = (
      billedPercent * item.invoiceCurrencyZeroVatTotal.ToNumber()
    ).ToAccountingRoundUpNumber();
    let currencyBilledPreVatTotal = (
      billedPercent * item.invoiceCurrencyPreVatTotal.ToNumber()
    ).ToAccountingRoundUpNumber();
    let currencyBilledVatTotal = (billedPercent * item.invoiceCurrencyVatTotal.ToNumber()).ToAccountingRoundUpNumber();
    let currencyBilledSubTotalForCalculateWht = (
      billedPercent * item.invoiceCurrencySubTotalForCalculateWht.ToNumber()
    ).ToAccountingRoundUpNumber();

    if (!item.isServiceOnly) {
      billingNoteIsServiceOnly = false;
    }
    invoiceNetAmount += item.invoiceNetAmount;

    totalBilledNetAmount += billedAmountItem;
    totalBilledVat += billedVatTotal;
    totalBilledPreVat += billedPreVatTotal;
    totalBilledZeroVat += billedZeroVatTotal;
    totalBilledVatExempted += billedVatExemptedTotal;
    totalBilledWht += item.isNoneOrNotSpecifyWht ? 0 : billedWhtItem;
    totalCurrencyBilledAmount += currencyBilledAmount;
    totalCurrencyBilledVat += currencyBilledVatTotal;
    totalCurrencyBilledPreVat += currencyBilledPreVatTotal;
    totalCurrencyBilledZeroVat += currencyBilledZeroVatTotal;
    totalCurrencyBilledVatExempted += currencyBilledVatExemptedTotal;
    totalCurrencyBilledWht += currencyBilledWht;
    transactionCreate.transactionItemList.push({
      id: item.invoiceId,
      invoiceId: item.invoiceId,
      invoiceNumber: item.invoiceNumber,
      invoiceDate: item.invoiceDate,
      invoiceDueDate: item.invoiceDueDate,

      invoiceVatExemptedTotal: item.invoiceVatExemptedTotal,
      invoiceZeroVatTotal: item.invoiceZeroVatTotal,
      invoicePreVatTotal: item.invoicePreVatTotal,
      invoiceVatTotal: item.invoiceVatTotal,
      invoiceSubTotalForCalculateWht: item.invoiceSubTotalForCalculateWht,
      invoiceWithCreditNoteNetAmount: item.invoiceWithCreditNoteNetAmount,

      remainCurrencyPaymentNetAmount: item.remainCurrencyPaymentNetAmount,
      remainPaymentAmount: item.remainPaymentAmount,
      remainWhtPaymentNetAmount: item.remainWhtPaymentNetAmount,

      invoiceCurrencyVatExemptedTotal: item.invoiceCurrencyVatExemptedTotal,
      invoiceCurrencyZeroVatTotal: item.invoiceCurrencyZeroVatTotal,
      invoiceCurrencyPreVatTotal: item.invoiceCurrencyPreVatTotal,
      invoiceCurrencyVatTotal: item.invoiceCurrencyVatTotal,
      invoiceCurrencySubTotalForCalculateWht: item.invoiceCurrencySubTotalForCalculateWht,
      invoiceCurrencyWithCreditNoteNetAmount: item.invoiceCurrencyWithCreditNoteNetAmount,
      creditNoteList: item.creditNoteList,

      invoiceNetAmount: item.invoiceNetAmount,

      isServiceOnly: item.isServiceOnly,
      sameProductVatType: item.sameProductVatType,
      isNoneOrNotSpecifyWht: item.isNoneOrNotSpecifyWht,
      toCurrencyUid: item.toCurrencyUid,
      fromCurrencyUid: item.fromCurrencyUid,

      referenceTransactionId: item.invoiceId,
      referenceTransactionTypeId: Enums.TransactionType.Invoice,

      billedIsInvoiceServiceOnly: item.isServiceOnly,
      billedIsNoneOrNotSpecifyWht: item.isNoneOrNotSpecifyWht,
      billedAmount: billedAmountItem,
      billedWht: item.isNoneOrNotSpecifyWht
        ? 0
        : (billedWhtPercent * item.remainWhtPaymentNetAmount.ToNumber()).ToAccountingRoundUpNumber(),
      billedVatExemptedTotal: billedVatExemptedTotal,
      billedZeroVatTotal: billedZeroVatTotal,
      billedPreVatTotal: billedPreVatTotal,
      billedVatTotal: billedVatTotal,
      billedSubTotalForCalculateWht: billedSubTotalForCalculateWht,
      currencyBilledAmount: currencyBilledAmount,
      billedInvoiceSameVatTypeProduct: item.sameProductVatType,
      currencyBilledSubTotalForCalculateWht: currencyBilledSubTotalForCalculateWht,

      currencyModel: {
        currencyNetAmount: item.invoiceNetAmount,
        currencyRatio: item.invoiceCurrencyRatio,
        currencyExchangeRates: item.invoiceCurrencyExchangeRates
          ? item.invoiceCurrencyExchangeRates
          : item.currencyModel.currencyExchangeRates,
        fromCurrencyUid: item.fromCurrencyUid != undefined ? item.fromCurrencyUid : item.currencyModel.fromCurrencyUid,
        toCurrencyUid: item.toCurrencyUid,
      },
    });
  });

  let setSameProductVatType = 0;
  let isHaveNotSpecify = false;
  let isHaveWht = false;
  for (
    let billedTransactionCount = 0;
    billedTransactionCount < transactionCreate.transactionItemList.length;
    billedTransactionCount++
  ) {
    if (transactionCreate.transactionItemList[billedTransactionCount].billedIsNoneOrNotSpecifyWht) {
      isHaveNotSpecify = true;
    }
    if (transactionCreate.transactionItemList[billedTransactionCount].billedWht != 0) {
      isHaveWht = true;
    }
    setSameProductVatType =
      setSameProductVatType == transactionCreate.transactionItemList[billedTransactionCount].sameProductVatType
        ? transactionCreate.transactionItemList[billedTransactionCount].sameProductVatType
        : Enums.SameProductVatType.Different;
  }
  if (isHaveWht) {
    billingNoteIsNoneOrNotSpecifyWht = false;
  } else if (isHaveNotSpecify) {
    billingNoteIsNoneOrNotSpecifyWht = true;
  }
  for (
    let billedTransactionCount = 0;
    billedTransactionCount < transactionCreate.transactionItemList.length;
    billedTransactionCount++
  ) {
    if (transactionCreate.transactionItemList[billedTransactionCount].toCurrencyUid == Enums.CurrencyCode.THB) {
      if (billingNoteIsNoneOrNotSpecifyWht) {
        totalBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? transactionCreate.transactionItemList[billedTransactionCount].billedSubTotalForCalculateWht
          : 0;
      } else {
        totalBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? 0
          : transactionCreate.transactionItemList[billedTransactionCount].billedSubTotalForCalculateWht;
      }
    } else {
      if (billingNoteIsNoneOrNotSpecifyWht) {
        totalBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? transactionCreate.transactionItemList[billedTransactionCount].billedSubTotalForCalculateWht
          : 0;

        totalCurrencyBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? transactionCreate.transactionItemList[billedTransactionCount].currencyBilledSubTotalForCalculateWht
          : 0;
      } else {
        totalBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? 0
          : transactionCreate.transactionItemList[billedTransactionCount].billedSubTotalForCalculateWht;

        totalCurrencyBilledSubTotalForCalculateWht += transactionCreate.transactionItemList[billedTransactionCount]
          .billedIsNoneOrNotSpecifyWht
          ? 0
          : transactionCreate.transactionItemList[billedTransactionCount].currencyBilledSubTotalForCalculateWht;
      }
    }
  }

  transactionCreate.transactionSummary.zeroVatTotal = totalBilledZeroVat;
  transactionCreate.transactionSummary.vatExemptedTotal = totalBilledVatExempted;
  transactionCreate.transactionSummary.taxExclusiveTotal = totalBilledZeroVat + totalBilledPreVat;
  transactionCreate.transactionSummary.subTotal = totalBilledVatExempted + totalBilledPreVat + totalBilledZeroVat;
  transactionCreate.transactionSummary.netAmount = totalBilledNetAmount;
  transactionCreate.transactionSummary.invoiceNetAmount = invoiceNetAmount;
  transactionCreate.transactionSummary.subTotalForCalculateWht = totalBilledSubTotalForCalculateWht;
  transactionCreate.transactionSummary.whtTotal = totalBilledWht;
  transactionCreate.transactionSummary.remainPaymentNetAmount = totalBilledNetAmount;
  transactionCreate.transactionSummary.remainWhtPaymentNetAmount = totalBilledWht;
  transactionCreate.transactionSummary.isNoneOrNotSpecifyWht = billingNoteIsNoneOrNotSpecifyWht;
  transactionCreate.transactionSummary.isServiceOnly = billingNoteIsServiceOnly;
  transactionCreate.transactionSummary.sameProductVatType = setSameProductVatType;
  transactionCreate.transactionSummary.vat.preVatTotal = totalBilledPreVat;
  transactionCreate.transactionSummary.vat.vatTotal = totalBilledVat;
  transactionCreate.transactionCurrencySummary.toCurrencyUId = result[0].toCurrencyUid;
  transactionCreate.currencyCode = transactionItemHelper
    .GetCurrencyMenuList()
    .find((x) => x.value === result[0].toCurrencyUid).currencyCode;

  transactionCreate.transactionCurrency = {
    fromCurrencyUid: result[0].fromCurrencyUid,
    toCurrencyUid: result[0].toCurrencyUid,
    currencyRatio: result[0].currencyRatio,
    currencyPreVatTotal: totalCurrencyBilledPreVat,
    currencyZeroVatTotal: totalCurrencyBilledZeroVat,
    currencyVatExemptedTotal: totalCurrencyBilledVatExempted,
    currencyVatTotal: totalCurrencyBilledVat,
    currencySubTotal: totalCurrencyBilledVatExempted + totalCurrencyBilledPreVat + totalCurrencyBilledZeroVat,
    currencyNetAmount: totalCurrencyBilledAmount,
    currencySubTotalForCalculateWht: totalCurrencyBilledSubTotalForCalculateWht,
    currencyWhtTotal: totalCurrencyBilledWht,
  };
  transactionCreate.transactionSummary.paymentWht = {
    isShow: transactionCreate.transactionSummary.whtTotal.FormatMoney() > 0 ? true : false,
    paymentNetAmount: transactionCreate.transactionSummary.netAmount.FormatMoney(),
    whtTotal: transactionCreate.transactionSummary.whtTotal.FormatMoney(),
  };
  return transactionCreate;
}
export default {
  GetCreateQuotationInput(status, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      dueDate: transaction.dueDate.hidden ? null : transaction.dueDate.value,
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value,
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
        creditLimit: transaction.contact.creditLimit,
        creditLimitSettingType: transaction.contact.creditLimitSettingType,
      },
      transactionItemType: transaction.transactionItemType,
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      referenceName: transaction.reference.referenceName,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          description: transactionItem.description.text,
          price: transactionItem.price.value.ToNumber(),
          amount: transactionItem.amount.value.ToNumber(),
          discount: transactionItem.discount.value.ToNumber(),
          vatType: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id,
          assetTemplateId: transactionItem.fixedAssetTemplate.id,
          isAcquisitionCost: transactionItem.fixedAssetTemplate.isService,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
          allocationTransactionList: transactionItem.isUseTransactionAllocation
            ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
            : GetCreateAllocationTransaction(transactionItem.allocationTransactionList),
        };
        transactionCreate.transactionItemList.push(_transactionItem);
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transactionCreate.transactionItemType,
    };
  },
  GetCreateInvoiceInput(status, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      dueDate: transaction.dueDate.value,
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value,
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
        creditLimit: transaction.contact.creditLimit,
        creditLimitSettingType: transaction.contact.creditLimitSettingType,
      },
      financeTypeId: transaction.financeType,
      expenseTypeId: transaction.expenseType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      purchaseTaxInvoiceRefNumber: null,
      purchaseTaxInvoiceRefDate: null,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      receivedTaxInvoiceList: [],
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.id > 0 ? transactionItem.productTemplate.code : "",
            fixAssetTemplateId: transactionItem.fixedAssetTemplate.id,
            isAcquisitionCost: transactionItem.fixedAssetTemplate.isService,
            fixAssetTemplateCode: transactionItem.fixedAssetTemplate.code,
            assetId: transactionItem.fixedAsset.id,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            sequenceNumber: 0,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransaction(transactionItem.allocationTransactionList),
            referenceQuotationItem: {
              referenceQuotationItemId: transactionItem.referenceQuotationItemId,
            },
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      expenseType: transaction.expenseType,
      transaction: transactionCreate,
    };
  },
  GetCreateReceiptInput(status, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          assetTemplateId: transactionItem.fixedAssetTemplate.id,
          assetId: transactionItem.fixedAsset.id,
          description: transactionItem.description.text,
          price: transactionItem.price.value.ToNumber(),
          amount: transactionItem.amount.value.ToNumber(),
          discount: transactionItem.discount.value.ToNumber(),
          vatType: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
          allocationTransactionList: transactionItem.isUseTransactionAllocation
            ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
            : GetCreateAllocationTransaction(transactionItem.allocationTransactionList),
        };
        transactionCreate.transactionItemList.push(_transactionItem);
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateCreditNoteInput(status, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      creditNoteReasonId: transaction.reasonType.value.id,
      creditNoteDescription: transaction.reasonDescription.text,
      isReturnStock: transaction.returnStock.value.id == Enums.ReturnStockType.Return ? true : false,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      receivedTaxInvoiceList: [],
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
      referenceTransactionAmount: summary.transactionSummary.referenceTransactionAmount.ToNumber(),
      referenceTransactionCurrencyAmount: summary.transactionCurrencySummary.referenceTransactionAmount.ToNumber(),
    };
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            assetTemplateId: transactionItem.fixedAssetTemplate.id,
            assetId: transactionItem.fixedAsset.id,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.code,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            referenceTransactionProductId: transactionItem.referenceTransactionProductId,
            sequenceNumber: 0,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransaction(transactionItem.allocationTransactionList),
            referenceStockActivityId: transactionItem.referenceStockActivityId,
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateDebitNoteInput(status, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      dueDate: transaction.dueDate.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      debitNoteReasonId: transaction.reasonType.value.id,
      debitNoteDescription: transaction.reasonDescription.text,
      isReturnStock: transaction.returnStock.value.id == Enums.ReturnStockType.Return ? true : false,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      receivedTaxInvoiceList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
      referenceTransactionAmount: summary.transactionSummary.referenceTransactionAmount.ToNumber(),
      referenceTransactionCurrencyAmount: summary.transactionCurrencySummary.referenceTransactionAmount.ToNumber(),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            assetTemplateId: transactionItem.fixedAssetTemplate.id,
            assetId: transactionItem.fixedAsset.id,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.code,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            sequenceNumber: 0,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransaction(transactionItem.allocationTransactionList),
            referenceStockActivityId: transactionItem.referenceStockActivityId,
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateBillingNoteInput(status, transaction) {
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      dueDate: transaction.dueDate.value.ToDateJsonString(),
      date: transaction.date.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      payment: ConvertPaymentForCreate(transaction.payment),
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxDocument.value,
      receivedBilligNoteNumber: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: transaction.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: transaction.transactionCurrency,
      fileList: [],
      tagList: transaction.tagList,
      transactionItemList: transaction.transactionItemList,
      currencyModel: transaction.currencyModel,
    };

    if (status != null) {
      transactionCreate.status = status;
    }
    return { financeType: transaction.financeType, transaction: transactionCreate };
  },
  GetCreateTaxInvoiceInput(status, transaction) {
    let transactionCreate = {
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      remark: transaction.remark.text,
      status: 0,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      fileList: [],
      tagList: transaction.tagList,
      referenceName: transaction.reference.referenceName,
    };
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transaction.financeType,
      transaction: transactionCreate,
    };
  },
  GetTagList(tagRawList) {
    let tagList = [];
    if (tagRawList && tagRawList.length > 0) {
      for (let tagRaw of tagRawList) {
        tagList.push({
          tagId: tagRaw.tagId,
          tagName: tagRaw.tagName,
        });
      }
    }
    return tagList;
  },
  ConvertToTransactionDetailForCreateTaxInvoice(transactionRaw) {
    let transaction = {
      number: transactionRaw.number,
      date: transactionRaw.date,
      isVat: transactionRaw.isVat,
      discount: transactionRaw.discount,
      remark: transactionRaw.remark,
      status: transactionRaw.status,
      financeTypeId: transactionRaw.financeTypeId,
      taxStatus: transactionRaw.taxStatus,
      referenceName: transactionRaw.referenceName,
      discountType: transactionRaw.discountType,
      transactionSummary: {
        subTotal: transactionRaw.transactionSummary.subTotal,
        netAmount: transactionRaw.transactionSummary.netAmount,
        whtTotal: transactionRaw.transactionSummary.whtTotal,
        vatExemptedTotal: transactionRaw.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transactionRaw.transactionSummary.zeroVatTotal,
        preVatTotal: transactionRaw.transactionSummary.preVatTotal,
        vatTotal: transactionRaw.transactionSummary.vatTotal,
        subTotalForCalculateWht: transactionRaw.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transactionRaw.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transactionRaw.transactionSummary.isServiceOnly,
        sameProductVatType: transactionRaw.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transactionRaw.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transactionRaw.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transactionRaw.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transactionRaw.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transactionRaw.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transactionRaw.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transactionRaw.transactionCurrency.currencyExchangeRates,
        currencyRatio: transactionRaw.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transactionRaw.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transactionRaw.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transactionRaw.transactionCurrency.toCurrencyUid,
      },
      contact: { id: transactionRaw.contact.id, contactCode: "" },
      tagList: [],
      referenceId: transactionRaw.referenceId,
      referenceType: transactionRaw.referenceType,
      transactionItemList: [],
      billingNoteTransactionList: [],
      isBillingNoteTransaction: transactionRaw.isBillingNoteTransaction,
      transactionItemType: transactionRaw.transactionItemType,
    };
    if (transactionRaw.tagList) {
      for (let tag of transactionRaw.tagList) {
        transaction.tagList.push({
          tagId: tag.tagId,
        });
      }
    }
    if (transactionRaw.isBillingNoteTransaction && transactionRaw.billingNoteTransactionList) {
      transaction.billingNoteTransactionList = CovertToBillingNoteTransaction(
        transactionRaw.billingNoteTransactionList
      );
    } else if (transactionRaw.transactionItemList) {
      for (let transactionItem of transactionRaw.transactionItemList) {
        transaction.transactionItemList.push({
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          accountId: transactionItem.accountId,
          netAmount: transactionItem.netAmount,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          assetId: transactionItem.assetId,
          fixAssetTemplateId: transactionItem.assetTemplateId,
        });
      }
    }
    return transaction;
  },
  ConvertToTransactionListForCreateTaxInvoice(transactionRawList) {
    let transactionList = [];
    if (transactionRawList) {
      for (let transactionRaw of transactionRawList) {
        transactionList.push({
          referenceName: transactionRaw.referenceName,
          referenceId: transactionRaw.referenceId,
          referenceType: transactionRaw.referenceType,
        });
      }
    }
    return transactionList;
  },
  GetFromAndToDate(month, year) {
    return {
      fromDate: new Date(year, month - 1, 1),
      toDate: new Date(year, month, 0),
    };
  },
  ConvertToQuotaitonDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.invoiceCount = _transaction.invoiceCount;
    transaction.transactionItemType = _transaction.transactionItemType;
    return transaction;
  },
  ConvertToTransactionDetail(_transaction) {
    return ConvertToTransactionDetail(_transaction);
  },
  ConvertToFileList(_fileList) {
    let fileList = [];
    if (_fileList.length > 0) {
      _fileList.forEach((item) => {
        fileList.push({
          id: item.id,
          fileName: item.fileName,
          fileFullUrl: item.fileUrl,
          fileType: item.fileType ? item.fileType : "",
          createDateTime: item.createDateTime,
          userId: item.userId,
          checkSendEmail: false,
        });
      });
    }
    return fileList;
  },
  ConvertToTagDetail(_tagDetail) {
    let tagDetail = [];
    if (_tagDetail.length > 0) {
      _tagDetail.forEach((item) => {
        tagDetail.push({
          tagId: item.tagId,
          tagName: item.tagName,
          transactionId: item.transactionId,
          transactionType: item.transactionType,
        });
      });
    }
    return tagDetail;
  },
  ConvertToInvoiceDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.billedCount = _transaction.billedCount;
    transaction.billedTotal = _transaction.billedTotal;
    transaction.billedTotalAwaitPaidPayment = _transaction.billedTotalAwaitPaidPayment;
    transaction.billedWhtTotal = _transaction.billedWhtTotal;
    transaction.creditNoteCount = _transaction.creditNoteCount;
    transaction.creditNoteTotal = _transaction.creditNoteTotal;
    transaction.creditNoteWhtTotal = _transaction.creditNoteWhtTotal;
    transaction.debitNoteCount = _transaction.debitNoteCount;
    transaction.referencePaymentDocumentCount = _transaction.referencePaymentDocumentCount;
    transaction.referencePaymentDocumentTotal = _transaction.referencePaymentDocumentTotal;
    transaction.paymentCount = _transaction.paymentCount;
    transaction.isHavePnd = _transaction.isHavePnd;
    transaction.paidTotal = _transaction.paidTotal;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isHavePayment = _transaction.paymentCount > 0;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
    return transaction;
  },
  ConvertToReceiptDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.paymentGroupId = _transaction.paymentGroupId;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = _transaction.creditNoteCount;
    transaction.creditNoteTotal = _transaction.creditNoteTotal;
    transaction.debitNoteCount = _transaction.debitNoteCount;
    transaction.paidTotal = _transaction.transactionSummary.netAmount;
    transaction.paidCount = 0;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.transactionItemType = _transaction.transactionItemType;
    if (transaction.referenceType === Enums.TransactionType.BillingNote) {
      transaction.isBillingNoteTransaction = true;
      transaction.transactionCurrency.currencyExchangeRates =
        _transaction.billingNoteTransactionList[0].currencyModel.currencyExchangeRates;
      transaction.transactionCurrency.currencyRatio =
        _transaction.billingNoteTransactionList[0].currencyModel.currencyRatio;
      transaction.billingNoteTransactionList = CovertToBillingNoteTransaction(_transaction.billingNoteTransactionList);
    }
    return transaction;
  },
  ConvertToTaxInvoiceDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.transactionItemType = _transaction.transactionItemType;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.isAutoGenerated = _transaction.isAutoGenerated;
    if (_transaction.referenceReceiptBillingNoteId > 0) {
      transaction.isBillingNoteTransaction = true;
      transaction.billingNoteTransactionList = CovertToBillingNoteTransaction(_transaction.billingNoteTransactionList);
    }
    return transaction;
  },
  ConvertToCreditNoteDetail(_transaction) {
    let transaction = this.ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.creditNoteStyleType = _transaction.creditNoteStyleType;
    transaction.referencePaymentDocumentCount = _transaction.referencePaymentDocumentCount;
    transaction.referencePaymentDocumentTotal = _transaction.referencePaymentDocumentTotal;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.paidTotal = _transaction.paidTotal;
    transaction.paymentCount = _transaction.paymentCount;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
    transaction.creditNoteReasonId = _transaction.creditNoteReasonId ? _transaction.creditNoteReasonId : 1;
    transaction.creditNoteDescription = _transaction.creditNoteDescription ? _transaction.creditNoteDescription : "";
    transaction.isReturnStock = _transaction.isReturnStock ? _transaction.isReturnStock : false;
    transaction.referenceTransactionAmount = _transaction.referenceTransactionAmount;
    transaction.referenceTransactionCurrencyAmount = _transaction.referenceTransactionCurrencyAmount;
    transaction.referenceTransactionCurrencyVatTotal = _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionVatTotal = _transaction.referenceTransactionVatTotal;
    transaction.referenceTransactionCurrencySubTotal =
      _transaction.referenceTransactionCurrencyAmount - _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionSubTotal =
      _transaction.referenceTransactionNetAmount - _transaction.referenceTransactionVatTotal;
    return transaction;
  },
  ConvertToDebitNoteDetail(_transaction) {
    let transaction = this.ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.creditNoteStyleType = _transaction.creditNoteStyleType;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.paidTotal = _transaction.paidTotal;
    transaction.paymentCount = _transaction.paymentCount;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
    transaction.debitNoteReasonId = _transaction.debitNoteReasonId ? _transaction.debitNoteReasonId : 1;
    transaction.debitNoteDescription = _transaction.debitNoteDescription ? _transaction.debitNoteDescription : "";
    transaction.isReturnStock = _transaction.isReturnStock ? _transaction.isReturnStock : false;
    transaction.referenceTransactionAmount = _transaction.referenceTransactionAmount;
    transaction.referenceTransactionCurrencyAmount = _transaction.referenceTransactionCurrencyAmount;
    transaction.referenceTransactionCurrencyVatTotal = _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionNetAmount = _transaction.referenceTransactionNetAmount;
    transaction.referenceTransactionVatTotal = _transaction.referenceTransactionVatTotal;
    transaction.referenceTransactionCurrencySubTotal =
      _transaction.referenceTransactionCurrencyAmount - _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionSubTotal =
      _transaction.referenceTransactionNetAmount - _transaction.referenceTransactionVatTotal;
    transaction.dueDate = _transaction.transactionDueDate;
    return transaction;
  },
  ConvertToBillingNoteDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.isBillingNoteTransaction = true;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.paidTotal = 0;
    transaction.paidCount = 0;
    transaction.referenceName = _transaction.receivedBilligNoteNumber;
    transaction.receivedBilligNoteNumber = _transaction.receivedBilligNoteNumber;
    transaction.referencePaymentDocumentCount = _transaction.referencePaymentDocumentCount;
    transaction.referencePaymentDocumentTotal = _transaction.referencePaymentDocumentTotal;
    transaction.billingNoteTransactionList = CovertToBillingNoteTransaction(_transaction.transactionItemList);
    transaction.payment = ConvertPaymentFromPaymentModel(_transaction.payment, false);
    if (
      _transaction.payment &&
      _transaction.payment.paymentGroupList &&
      _transaction.payment.paymentGroupList.length > 0
    ) {
      transaction.isNotSuggestionPayment = true;
    }
    return transaction;
  },
  ConvertReceiptBillingNoteCreate(transactionRaw) {
    let paymentDisabled =
      transactionRaw.payment &&
      transactionRaw.payment.paymentGroupList &&
      transactionRaw.payment.paymentGroupList.length > 0;
    let receipt = {
      referenceName: transactionRaw.referenceName,
      referenceId: transactionRaw.referenceId.ToNumber(),
      referenceType: transactionRaw.referenceType,
      paymentGroupId: transactionRaw.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transactionRaw.transactionSummary.subTotal,
        netAmount: transactionRaw.transactionSummary.netAmount,
        whtTotal: transactionRaw.transactionSummary.whtTotal,
        vatExemptedTotal: transactionRaw.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transactionRaw.transactionSummary.zeroVatTotal,
        preVatTotal: transactionRaw.transactionSummary.preVatTotal,
        vatTotal: transactionRaw.transactionSummary.vatTotal,
        subTotalForCalculateWht: transactionRaw.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transactionRaw.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transactionRaw.transactionSummary.isServiceOnly,
        sameProductVatType: transactionRaw.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transactionRaw.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transactionRaw.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transactionRaw.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transactionRaw.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transactionRaw.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transactionRaw.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transactionRaw.transactionCurrency.currencyExchangeRates,
        currencyRatio: transactionRaw.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transactionRaw.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transactionRaw.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transactionRaw.transactionCurrency.toCurrencyUid,
      },
      contact: { id: transactionRaw.contact.id, contactCode: "" },
      billingNoteTransactionList: [],
      isBillingNoteTransaction: true,
      payment: ConvertPaymentFromPaymentModel(transactionRaw.payment, paymentDisabled),
    };
    if (transactionRaw.billingNoteTransactionList) {
      receipt.transactionCurrency.currencyExchangeRates =
        transactionRaw.billingNoteTransactionList[0].currencyModel.currencyExchangeRates;
      receipt.transactionCurrency.currencyRatio =
        transactionRaw.billingNoteTransactionList[0].currencyModel.currencyRatio;
      receipt.billingNoteTransactionList = CovertToBillingNoteTransaction(transactionRaw.billingNoteTransactionList);
    }

    return receipt;
  },
  ConvertReceiptInvoiceCreate(transactionRaw) {
    let paymentDisabled =
      transactionRaw.payment &&
      transactionRaw.payment.paymentGroupList &&
      transactionRaw.payment.paymentGroupList.length > 0;
    let receipt = {
      referenceName: transactionRaw.referenceName,
      referenceId: transactionRaw.referenceId.ToNumber(),
      referenceType: transactionRaw.referenceType,
      date: transactionRaw.date,
      paymentGroupId: transactionRaw.referencePaymentGroupId,
      discount: transactionRaw.discount,
      discountType: transactionRaw.discountType,
      taxStatus: transactionRaw.taxStatus,
      transactionSummary: {
        subTotal: transactionRaw.transactionSummary.subTotal,
        netAmount: transactionRaw.transactionSummary.netAmount,
        whtTotal: transactionRaw.transactionSummary.whtTotal,
        vatExemptedTotal: transactionRaw.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transactionRaw.transactionSummary.zeroVatTotal,
        preVatTotal: transactionRaw.transactionSummary.preVatTotal,
        vatTotal: transactionRaw.transactionSummary.vatTotal,
        subTotalForCalculateWht: transactionRaw.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transactionRaw.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transactionRaw.transactionSummary.isServiceOnly,
        sameProductVatType: transactionRaw.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transactionRaw.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transactionRaw.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transactionRaw.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transactionRaw.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transactionRaw.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transactionRaw.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transactionRaw.transactionCurrency.currencyExchangeRates,
        currencyRatio: transactionRaw.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transactionRaw.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transactionRaw.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transactionRaw.transactionCurrency.toCurrencyUid,
      },
      contact: { id: transactionRaw.contact.id, contactCode: "" },
      isBillingNoteTransaction: false,
      payment: ConvertPaymentFromPaymentModel(transactionRaw.payment, paymentDisabled),
      transactionItems: [],
      allocationTransactionList: transactionRaw.allocationTransactionList,
      transactionItemType: transactionRaw.transactionItemType,
    };

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transactionRaw.taxStatus,
      transactionRaw.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRaw.discount,
      transactionRaw.discountType,
      transactionRaw.taxStatus
    );

    if (transactionRaw.transactionItemList && transactionRaw.transactionItemList.length > 0) {
      transactionRaw.transactionItemList.forEach((transactionItems) => {
        let transactionItemsTemplate = {
          id: transactionItems.id,
          productTemplateId: transactionItems.productTemplateId,
          productTemplateCode: transactionItems.code,
          description: transactionItems.description,
          price: transactionItems.price,
          amount: transactionItems.amount,
          discount: transactionItems.discount,
          vatType: transactionItems.vatType,
          discountType: transactionItems.discountType,
          netAmount: transactionItems.netAmount,
          accountId: transactionItems.accountId,
          isDescriptionOnly: transactionItems.isDescriptionOnly,
          accountRefId: transactionItems.accountRefId,
          accountRefTypeId: transactionItems.accountRefTypeId,
          whtAmount: transactionItems.whtAmount,
          whtAmountType: transactionItems.whtAmountType,
          taxIncomeTypeId: transactionItems.taxIncomeTypeId,
          subTotal: transactionItems.subTotal,
          assetId: transactionItems.assetId,
          fixAssetTemplateId: transactionItems.assetTemplateId,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItems.allocationTransactionList
          ),
        };
        if (transactionItemsTemplate.allocationList && transactionItemsTemplate.allocationList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            receipt.allocationTransactionList,
            transactionItemsTemplate.allocationList
          );
          transactionItemsTemplate.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItems
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transactionRaw.transactionCurrency.toCurrencyUid,
          transactionRaw.transactionCurrency.currencyExchangeRates,
          transactionRaw.transactionCurrency.currencyRatio,
          transactionRaw.taxStatus,
          transactionRaw.isCreatedTaxInvoice,
          transactionRaw.transactionType,
          transactionRaw.financeType,
          false
        );

        transactionItemsTemplate.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        transactionItemsTemplate.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        receipt.transactionItems.push(transactionItemsTemplate);
      });
    }
    return receipt;
  },
  ConvertToBillingNoteTransactionInvoiceDetail(_billingNoteTransactionList) {
    let billingNoteTransactionList = [];
    if (_billingNoteTransactionList) {
      _billingNoteTransactionList.forEach((billingTransaction) => {
        billingNoteTransactionList.push({
          actionDate: billingTransaction.actionDate,
          billedAmount: billingTransaction.billedAmount,
          billedWHT: billingTransaction.billedWHT,
          billingNoteId: billingTransaction.billingNoteId,
          billingNoteNumber: billingTransaction.billingNoteNumber,
          billingNoteTransactionId: billingTransaction.billingNoteTransactionId,
          dueDate: billingTransaction.dueDate,
          financeType: billingTransaction.financeType,
          invoiceNetAmount: billingTransaction.invoiceNetAmount,
          invoiceSubTotal: billingTransaction.invoiceSubTotal,
          paymentModel: billingTransaction.paymentModel,
          status: billingTransaction.status,
          transactionStatus: billingTransaction.transactionStatus,
          uuid: billingTransaction.uuid,
          paymentSummary: {},
        });
      });
    }
    return billingNoteTransactionList;
  },
  ConvertToReceiptEdit(transaction) {
    let paymentDisabled =
      (transaction.referenceType === Enums.TransactionType.BillingNote ||
        transaction.referenceType === Enums.TransactionType.Invoice) &&
      transaction.referencePaymentGroupId != 0;
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      referencePaymentGroupId: transaction.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      billingNoteTransactionList: CovertToBillingNoteTransaction(transaction.billingNoteTransactionList),
      payment: ConvertPaymentFromPaymentModel(transaction.payment, paymentDisabled),
      isNotSuggestionPayment: false,
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
      transactionItemType: transaction.transactionItemType,
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
    }

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code ? transactionItem.code : transactionItem.productTemplateCode,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          assetId: transactionItem.assetId,
          fixAssetTemplateId: transactionItem.assetTemplateId,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            transactionEdit.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  ConvertToRecurringReceiptForDetail(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
      },
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      referencePaymentGroupId: transaction.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      billingNoteTransactionList: CovertToBillingNoteTransaction(transaction.billingNoteTransactionList),
      payment: ConvertPaymentFromPaymentModel(transaction.payment, true),
      isNotSuggestionPayment: false,
      allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };

    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
    }

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
        };

        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  ConvertToCreditNoteSummaryList(_creditNoteSummaryList) {
    let creditNoteSummaryList = [];
    if (_creditNoteSummaryList !== null && _creditNoteSummaryList.length > 0) {
      _creditNoteSummaryList.forEach((creditNoteSummaryItem) => {
        creditNoteSummaryList.push({
          creditNoteId: creditNoteSummaryItem.creditNoteId,
          date: creditNoteSummaryItem.date,
          number: creditNoteSummaryItem.number,
          netAmount: creditNoteSummaryItem.netAmount,
          lockStatusId: creditNoteSummaryItem.lockStatusId,
          lockDateTime: creditNoteSummaryItem.lockDateTime,
          lockUserId: creditNoteSummaryItem.lockUserId,
          deductedAmount: creditNoteSummaryItem.deductedAmount,
          returnAmount: creditNoteSummaryItem.returnAmount,
          reasonId: creditNoteSummaryItem.reasonId,
          reasonDescription: creditNoteSummaryItem.reasonDescription,
          isReturnStock: creditNoteSummaryItem.isReturnStock,
          referencedJournal: [],
          paymentSummary: {},
        });
      });
    }
    return creditNoteSummaryList;
  },
  ConvertToDebitNoteSummaryList(_debitNoteSummaryList) {
    let debitNoteSummaryList = [];
    if (_debitNoteSummaryList !== null && _debitNoteSummaryList.length > 0) {
      _debitNoteSummaryList.forEach((debitNoteSummaryItem) => {
        debitNoteSummaryList.push({
          debitNoteId: debitNoteSummaryItem.debitNoteId,
          date: debitNoteSummaryItem.date,
          number: debitNoteSummaryItem.number,
          netAmount: debitNoteSummaryItem.netAmount,
          lockStatusId: debitNoteSummaryItem.lockStatusId,
          lockDateTime: debitNoteSummaryItem.lockDateTime,
          lockUserId: debitNoteSummaryItem.lockUserId,
          addAmount: debitNoteSummaryItem.addAmount,
          returnAmount: debitNoteSummaryItem.returnAmount,
          reasonId: debitNoteSummaryItem.reasonId,
          reasonDescription: debitNoteSummaryItem.reasonDescription,
          isReturnStock: debitNoteSummaryItem.isReturnStock,
          referencedJournal: [],
          paymentSummary: {},
        });
      });
    }
    return debitNoteSummaryList;
  },
  ConvertToTransactionForDoPaidPayment(_transaction) {
    let transaction = {
      id: _transaction.id,
      number: _transaction.number,
      date: _transaction.date,
      contactId: _transaction.contactId,
      transactionType: _transaction.transactionType,
      financeType: _transaction.financeType,
      expenseType: _transaction.expenseType,
      isCreatedTaxInvoice: _transaction.isCreatedTaxInvoice,
      transactionSummary: {
        preVatTotal: _transaction.transactionSummary.preVatTotal,
        zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
        vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
        taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
        vatTotal: _transaction.transactionSummary.vatTotal,
        subTotal: _transaction.transactionSummary.subTotal,
        netAmount: _transaction.transactionSummary.netAmount,
        subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
        whtTotal: _transaction.transactionSummary.whtTotal,
        remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
        remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
        isAllNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: _transaction.transactionSummary.isServiceOnly,
        sameProductVatType: _transaction.transactionSummary.sameProductVatType,
      },
    };
    return transaction;
  },
  ConvertPaymentForCreate(paymentRaw) {
    return ConvertPaymentForCreate(paymentRaw);
  },
  ConvertToQuotationTimeline(timelineRaw) {
    let timeline = {
      invoiceList: [],
      receiptList: ConvertToTransactionTimelineReceiptWithJournal(timelineRaw.receiptList),
    };
    if (timelineRaw.invoiceList) {
      for (let invoiceRaw of timelineRaw.invoiceList) {
        let invoice = {
          invoiceId: invoiceRaw.invoiceId,
          invoiceNumber: invoiceRaw.invoiceNumber,
          invoiceIsCreatedTaxInvoice: invoiceRaw.invoiceIsCreatedTaxInvoice,
          invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
          taxInvoiceId: invoiceRaw.taxInvoiceId,
          taxInvoiceNumber: invoiceRaw.taxInvoiceNumber,
          journalList: ConvertToTransactionTimelineJournal(invoiceRaw.journalList),
          receiptList: ConvertToTransactionTimelineReceipt(invoiceRaw.receiptList),
          billingNoteList: ConvertToTransactionTimelineInvoiceBillingNote(invoiceRaw.billingNoteList),
        };
        timeline.invoiceList.push(invoice);
      }
    }
    return timeline;
  },
  ConvertToInvoiceTimeline(timelineRaw) {
    let timeline = {
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      taxInvoiceNumber: timelineRaw.taxInvoiceNumber,
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      receiptList: ConvertToTransactionTimelineReceipt(timelineRaw.receiptList),
      billingNoteList: ConvertToTransactionTimelineInvoiceBillingNote(timelineRaw.billingNoteList),
    };
    return timeline;
  },
  ConvertToReceiptTimeline(timelineRaw) {
    let timeline = {
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      invoiceId: timelineRaw.invoiceId,
      invoiceNumber: timelineRaw.invoicenNumber,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      taxInvoiceNumber: timelineRaw.taxInvoiceNumber,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptReferenceType: timelineRaw.receiptReferenceType,
      billingNoteId: timelineRaw.billingNoteId,
      billingNoteNumber: timelineRaw.billingNoteNumber,
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
    };
    return timeline;
  },
  ConvertToCreditNoteTimeline(timelineRaw) {
    let timeline = {
      invoiceId: timelineRaw.invoiceId,
      receiptId: timelineRaw.receiptId,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
    };
    return timeline;
  },
  ConvertToDebitNoteTimeline(timelineRaw) {
    let timeline = {
      invoiceId: timelineRaw.invoiceId,
      receiptId: timelineRaw.receiptId,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
    };
    return timeline;
  },
  ConvertToTaxInvoiceTimeline(timelineRaw) {
    let timeline = {
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      invoiceId: timelineRaw.invoiceId,
      invoiceNumber: timelineRaw.invoiceNumber,
      receiptId: timelineRaw.receiptId,
      receiptNumber: timelineRaw.receiptNumber,
      receiptReferenceType: timelineRaw.receiptReferenceType,
      billingNoteId: timelineRaw.billingNoteId,
      billingNoteNumber: timelineRaw.billingNoteNumber,
    };
    return timeline;
  },
  ConvertToBillingNoteTimeline(timelineRaw) {
    let timeline = {
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      receiptList: ConvertToTransactionTimelineReceipt(timelineRaw.receiptList),
    };
    return timeline;
  },
  ConvertToPurchaseOrderTimeline(timelineRaw) {
    let timeline = {
      expenseList: [],
    };
    if (timelineRaw.expenseList) {
      for (let expenseRaw of timelineRaw.expenseList) {
        let expense = {
          expenseId: expenseRaw.expenseId,
          expenseNumber: expenseRaw.expenseNumber,
          journalList: ConvertToTransactionTimelineJournal(expenseRaw.journalList),
          combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(expenseRaw.combinePaymentNoteList),
        };
        timeline.expenseList.push(expense);
      }
    }
    return timeline;
  },
  ConvertToExpenseTimeline(timelineRaw) {
    let timeline = {
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(timelineRaw.combinePaymentNoteList),
    };
    return timeline;
  },
  ConvertToBillingNoteForEdit(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contactId: {
        id: transaction.contactId,
      },
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        transactionEdit.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }
    if (transaction.billingNoteTransactionList) {
      for (let transactionItem of transaction.billingNoteTransactionList) {
        let _transactionItem = {
          id: transactionItem.id,
          billedAmount: transactionItem.billedAmount,
          isAllNoneOrNotSpecifyWht: transactionItem.isAllNoneOrNotSpecifyWht,
          invoiceDate: transactionItem.invoiceDate,
          invoiceDueDate: transactionItem.invoiceDueDate,
          invoiceId: transactionItem.invoiceId,
          invoiceNetAmount: transactionItem.invoiceNetAmount,
          invoiceNumber: transactionItem.invoiceNumber,
          whtAmount: transactionItem.whtAmount,
          creditNoteList: transactionItem.creditNoteList,
          currencyBilledAmount: transactionItem.currencyBilledAmount,
          currencyModel: transactionItem.currencyModel,
        };
        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  ConvertToCreditNoteModel(transaction) {
    let creditNote = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      creditNoteReasonId: transaction.creditNoteReasonId ? transaction.creditNoteReasonId : 0,
      creditNoteDescription: transaction.creditNoteDescription ? transaction.creditNoteDescription : "",
      isReturnStock: transaction.isReturnStock ? transaction.isReturnStock : false,
      creditNoteStyleType: transaction.creditNoteStyleType,
      creditNoteAmount: transaction.creditNoteAmount,
      creditNoteWaitingPaidTotal: transaction.creditNoteWaitingPaidTotal,
      referenceTransactionAmount: transaction.referenceTransactionAmount,
      referenceTransactionCurrencyAmount: transaction.referenceTransactionCurrencyAmount,
      totalDocumentAmountAfterCreditNote: transaction.totalDocumentAmountAfterCreditNote,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      creditNote.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        creditNote.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          isReturnStock: transactionItem.isReturnStock,
          referenceTransactionProductId: transactionItem.referenceTransactionProductId,
          allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            creditNote.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        creditNote.transactionItemList.push(_transactionItem);
      }
    }
    return creditNote;
  },
  ConvertToDebitNoteModel(transaction) {
    let debitNote = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      userId: transaction.userId,
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      debitNoteReasonId: transaction.debitNoteReasonId,
      debitNoteDescription: transaction.debitNoteDescription,
      isReturnStock: transaction.isReturnStock,
      debitNoteStyleType: transaction.debitNoteStyleType,
      debitNoteAmount: transaction.debitNoteAmount,
      referenceTransactionAmount: transaction.referenceTransactionAmount,
      referenceTransactionCurrencyAmount: transaction.referenceTransactionCurrencyAmount,
      totalDocumentAmountAfterDebitNote: transaction.totalDocumentAmountAfterDebitNote,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      debitNote.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        debitNote.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }
    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
          referenceStockActivityId: transactionItem.referenceStockActivityId,
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            debitNote.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        debitNote.transactionItemList.push(_transactionItem);
      }
    }
    return debitNote;
  },
  ConvertToInvoiceForEdit(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      userId: transaction.userId,
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        transactionEdit.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code ? transactionItem.code : transactionItem.productTemplateCode,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isAcquisitionCost: transactionItem.isAcquisitionCost,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
          referenceQuotationItem: {
            discount: transactionItem.referenceQuotationItem.discount,
            discountType: transactionItem.referenceQuotationItem.discountType,
            price: transactionItem.referenceQuotationItem.price,
            referenceQuotationItemId: transactionItem.referenceQuotationItem.referenceQuotationItemId,
            remainingQuantity: transactionItem.referenceQuotationItem.remainingQuantity,
            whtAmount: transactionItem.referenceQuotationItem.whtAmount,
            whtAmountType: transactionItem.referenceQuotationItem.whtAmountType,
          },
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            transactionEdit.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();
        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  ConvertToRecurringInvoiceForDetail(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contact: {
        id: transaction.contact.id,
      },
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: ConvertPaymentFromPaymentModel(transaction.payment, true),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        transactionEdit.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
        };
        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }

    return transactionEdit;
  },
  ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType) {
    return ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType);
  },
  GetCreateBookmarkInput(setBookmark, transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let transactionCreate = {
      id: 0,
      name: setBookmark.name.value,
      isRememberContact: setBookmark.isRememberContact,
      isRememberAmountAndPrice: setBookmark.isRememberAmountAndPrice,
      description: setBookmark.description.value,
      transactionType: transaction.transactionType,
      financeType: transaction.financeType,
      transactionTemplateModel: {
        id: 0,
        expenseType: transaction.expenseType,
        taxStatus: transaction.taxStatus.value,
        status: 0,
        remark: transaction.remark.text,
        discount: transaction.transactionDiscount.value.ToNumber(),
        discountType: transaction.transactionDiscount.discountType,
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isCreateTaxInvoice: transaction.issueTaxInvoice.value ? 1 : 0,
        isTaxDocument: transaction.issueTaxDocument.value ? 1 : 0,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatTypeId: transaction.transactionSummary.sameProductVatType,
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
        // contactId: setBookmark.isRememberContact == 1 ? transaction.contact.id : 0,
        contactId: transaction.contact.id,
      },
      transactionTemplateProductModel: [],
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          description: transactionItem.description.text,
          price: setBookmark.isRememberAmountAndPrice == 1 ? transactionItem.price.value.ToNumber() : 0,
          amount: setBookmark.isRememberAmountAndPrice == 1 ? transactionItem.amount.value.ToNumber() : 1,
          discount: transactionItem.discount.value.ToNumber(),
          vatTypeId: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id == 0 ? null : transactionItem.productTemplate.id,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
        };
        transactionCreate.transactionTemplateProductModel.push(_transactionItem);
      }
    }
    return transactionCreate;
  },
  //#region bookmark
  GetBookmarkListInput(input) {
    return {
      merchantId: userInfo.MerchantId(),
      transactionType: input.transactionType,
      financeType: input.financeType,
      expenseType: input.financeType == Enums.FinanceType.InFlow ? 0 : input.expenseType ? input.expenseType : 0,
    };
  },
  GetBookmarkDetailListInput(transactionTemplateId) {
    return {
      merchantId: userInfo.MerchantId(),
      transactionTemplateId: transactionTemplateId,
    };
  },
  GetBookmarkTemplateInput(bookmarkId) {
    return {
      merchantId: userInfo.MerchantId(),
      bookmarkId: bookmarkId,
    };
  },
  GetLatestUserdInput(financeTypeId, expenseTypeId, contactId) {
    return {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
      financeTypeId: financeTypeId,
      expenseTypeId: expenseTypeId,
    };
  },
  DeleteBookmarkInput(bookmarkId) {
    return {
      merchantId: userInfo.MerchantId(),
      bookmarkId: bookmarkId,
    };
  },
  GetBookmarkList(bookmarkOutputList) {
    let bookmarkList = [];
    if (bookmarkOutputList != null) {
      for (let count = 0; count < bookmarkOutputList.length; count++) {
        let bookmarkItem = bookmarkOutputList[count];
        let bookmark = {
          id: bookmarkItem.id,
          name: bookmarkItem.name,
          description: bookmarkItem.description,
          contactId: bookmarkItem.contactId,
          netAmount: bookmarkItem.netAmount,
          isRememberAmountAndPrice: bookmarkItem.isRememberAmountAndPrice,
          transactiontemplateId: bookmarkItem.transactiontemplateId,
          bookmarkDetail: null,
        };
        bookmarkList.push(bookmark);
      }
    }
    return bookmarkList;
  },
  GetBookmarkDetailList(bookmarkDetailOutputList) {
    let bookmarkDetailList = [];
    if (bookmarkDetailOutputList != null) {
      for (let count = 0; count < bookmarkDetailOutputList.length; count++) {
        if (count < 5) {
          let bookmarkDetailItem = bookmarkDetailOutputList[count];
          let bookmark = {
            count: count + 1,
            amount: bookmarkDetailItem.amount,
            descriptionProduct: bookmarkDetailItem.descriptionProduct,
          };
          bookmarkDetailList.push(bookmark);
        }
      }
    }
    return bookmarkDetailList;
  },
  ConvertBookmarkDetailToTransactionDetail(bookmarkModel) {
    let bookmarkTemplate = {
      id: bookmarkModel.id,
      name: bookmarkModel.name,
      isRememberContact: bookmarkModel.isRememberContact,
      isRememberAmountAndPrice: bookmarkModel.isRememberAmountAndPrice,
      description: bookmarkModel.description,
      transactionType: bookmarkModel.transactionType,
      financeType: bookmarkModel.financeType,
      transactionTemplateId: bookmarkModel.transactionTemplateDetailModel.id,
      contactId: bookmarkModel.transactionTemplateDetailModel.contactId,
      contactCode: "",
      expenseType: bookmarkModel.transactionTemplateDetailModel.expenseType,
      taxStatus: bookmarkModel.transactionTemplateDetailModel.taxStatus,
      status: bookmarkModel.transactionTemplateDetailModel.status,
      remark: bookmarkModel.transactionTemplateDetailModel.remark,
      discount: bookmarkModel.transactionTemplateDetailModel.discount,
      discountType: bookmarkModel.transactionTemplateDetailModel.discountType,
      isAllNoneOrNotSpecifyWht: bookmarkModel.transactionTemplateDetailModel.isAllNoneOrNotSpecifyWht,
      isServiceOnly: bookmarkModel.transactionTemplateDetailModel.isServiceOnly,
      netAmount: bookmarkModel.transactionTemplateDetailModel.netAmount,
      subTotal: bookmarkModel.transactionTemplateDetailModel.subTotal,
      preVatTotal: bookmarkModel.transactionTemplateDetailModel.preVatTotal,
      zeroVatTotal: bookmarkModel.transactionTemplateDetailModel.zeroVatTotal,
      vatTotal: bookmarkModel.transactionTemplateDetailModel.vatTotal,
      vatExemtedTotal: bookmarkModel.transactionTemplateDetailModel.vatExemtedTotal,
      subTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.subTotalForCalculateWht,
      whtTotal: bookmarkModel.transactionTemplateDetailModel.whtTotal,
      sameProductVatTypeId: bookmarkModel.transactionTemplateDetailModel.sameProductVatTypeId,
      currencyExchangeRates: bookmarkModel.transactionTemplateDetailModel.currencyExchangeRates,
      fromCurrencyUid: bookmarkModel.transactionTemplateDetailModel.fromCurrencyUid,
      toCurrencyUid: bookmarkModel.transactionTemplateDetailModel.toCurrencyUid,
      currencyRatio: bookmarkModel.transactionTemplateDetailModel.currencyRatio,
      currencyNetAmount: bookmarkModel.transactionTemplateDetailModel.currencyNetAmount,
      currencyPreVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyPreVatTotal,
      currencyZeroVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyZeroVatTotal,
      currencyVatExemptedTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatExemptedTotal,
      currencySubTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.currencySubTotalForCalculateWht,
      currencyVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatTotal,
      currencyWhtTotal: bookmarkModel.transactionTemplateDetailModel.currencyWhtTotal,
      isCreateTaxInvoice: bookmarkModel.transactionTemplateDetailModel.isCreateTaxInvoice,
      transactionItems: [],
    };
    if (
      bookmarkModel.transactionTemplateProductDetailModel &&
      bookmarkModel.transactionTemplateProductDetailModel.length > 0
    ) {
      bookmarkModel.transactionTemplateProductDetailModel.forEach((items) => {
        let bookmarkItemsTemplate = {
          accountCode: items.accountCode,
          productTemplateCode: items.productTemplateCode,
          sequenceNumber: items.sequenceNumber,
          description: items.description,
          isDescriptionOnly: items.isDescriptionOnly,
          productTemplateId: items.productTemplateId,
          accountId: items.accountId,
          price: items.price,
          amount: items.amount,
          discount: items.discount,
          discountType: items.discountType,
          vatType: items.vatTypeId,
          netAmount: items.netAmount,
          whtAmount: items.whtAmount,
          whtAmountType: items.whtAmountTypeId,
          typeId: items.typeId,
        };
        bookmarkTemplate.transactionItems.push(bookmarkItemsTemplate);
      });
    }
    return bookmarkTemplate;
  },
  ConvertToAISuggestionAccountByContact(aiSuggestionTransactionRaw) {
    let aiSuggestionTransaction = {
      isActive: false,
      expenseTypeId: 0,
      transactionId: 0,
      chartOfAccountList: [],
      suggestionAccountMongoId: "",
    };
    if (aiSuggestionTransactionRaw && aiSuggestionTransactionRaw.transactionId > 0) {
      aiSuggestionTransaction.isActive = true;
      aiSuggestionTransaction.transactionId = aiSuggestionTransactionRaw.transactionId;
      aiSuggestionTransaction.expenseTypeId = aiSuggestionTransactionRaw.expenseTypeId;
    } else if (
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts.length > 0
    ) {
      aiSuggestionTransaction.isActive = true;
      aiSuggestionTransaction.suggestionAccountMongoId = aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id;
      for (let chartOfAccount of aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts) {
        aiSuggestionTransaction.chartOfAccountList.push({ accountId: chartOfAccount.accountId });
      }
    }
    return aiSuggestionTransaction;
  },
  ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList) {
    return ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList);
  },
  GetCreateAllocationTransaction(allocationTransacionRawList) {
    return GetCreateAllocationTransaction(allocationTransacionRawList);
  },
  GetCreateAllocationTransactionItem(allocationTransacionItemRawList) {
    return GetCreateAllocationTransactionItem(allocationTransacionItemRawList);
  },
  //#endregion
  SetBillingNoteCESummerryAndCurrency(transactionCreate, result) {
    return SetBillingNoteCESummerryAndCurrency(transactionCreate, result);
  },
  ConvertToReferenceDocumentPaymentModel(_referenceDocumentPaymentList) {
    let referenceDocumentPaymentList = [];

    if (_referenceDocumentPaymentList && _referenceDocumentPaymentList.length > 0) {
      _referenceDocumentPaymentList.forEach((_referenceDocumentPayment) => {
        let referenceDocumentPayment = {
          id: _referenceDocumentPayment.id,
          transactionType: _referenceDocumentPayment.transactionType,
          number: _referenceDocumentPayment.number,
          remainPayment: _referenceDocumentPayment.remainPayment,
        };
        referenceDocumentPaymentList.push(referenceDocumentPayment);
      });
    }

    return referenceDocumentPaymentList;
  },
  ConvertToTransactionForCreateCreditNoteModel(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      _transactionList.forEach((_transaction) => {
        let transaction = {
          id: _transaction.id,
          number: _transaction.number,
          issueDate: _transaction.issueDate,
        };
        transactionList.push(transaction);
      });
    }
    return transactionList;
  },
  ConvertToTransactionForCreateDebitNoteModel(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      _transactionList.forEach((_transaction) => {
        let transaction = {
          id: _transaction.id,
          number: _transaction.number,
          issueDate: _transaction.issueDate,
        };
        transactionList.push(transaction);
      });
    }
    return transactionList;
  },
  ConvertTransactionItemBaseModelForEasyEdit(productItem, transactionModel) {
    let baseTransactionItem = transactionHelper.GetCreateTransactionItemDefualt(
      transactionModel.transactionType,
      transactionModel.financeType,
      transactionModel.expenseType
    );
    let isCanEdit = true;
    baseTransactionItem.productTemplate.id = productItem.productTemplateId;
    baseTransactionItem.productTemplate.code = productItem.productTemplateCode;
    baseTransactionItem.productTemplate.isNotAuto = true;

    baseTransactionItem.id = productItem.id;
    baseTransactionItem.account.disabled = false;

    baseTransactionItem.referencePrice = productItem.price.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceAmount = productItem.amount.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceDescription = productItem.description;
    baseTransactionItem.referenceDiscount = productItem.discount.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceDiscountType = productItem.discountType;
    baseTransactionItem.referenceStockActivityId = productItem.referenceStockActivityId;
    baseTransactionItem.isDescriptionOnly = productItem.isDescriptionOnly;

    baseTransactionItem.account.id = productItem.accountId;
    baseTransactionItem.account.code = productItem.accountCode;
    baseTransactionItem.account.isNotAuto = true;
    baseTransactionItem.account.disabled = !isCanEdit;

    baseTransactionItem.description.text = productItem.description != null ? productItem.description : "";
    baseTransactionItem.description.disabled = !isCanEdit;
    baseTransactionItem.description.validateError = false;
    baseTransactionItem.amount.value = productItem.amount.ToPeakTransactionItemFormat();
    baseTransactionItem.amount.disabled = !isCanEdit;
    baseTransactionItem.price.value = productItem.price.ToPeakTransactionItemFormat();
    baseTransactionItem.price.disabled = !isCanEdit;
    baseTransactionItem.discount.value = productItem.discount.ToPeakTransactionItemFormat();
    baseTransactionItem.discount.discountTypeId = productItem.discountType;
    baseTransactionItem.discount.disabled = !isCanEdit;
    baseTransactionItem.vatTypeId.value = productItem.vatType;
    baseTransactionItem.vatTypeId.disabled = !isCanEdit;
    baseTransactionItem.itemWht.value = productItem.whtAmount;
    baseTransactionItem.itemWht.whtAmountType = productItem.whtAmountType;
    baseTransactionItem.itemWht.disabled = !isCanEdit;
    if (baseTransactionItem.itemWht.whtAmountType !== 0) {
      baseTransactionItem.itemWht.isNotAuto = true;
    }
    baseTransactionItem.itemNetAmountWithAllocateDiscountTotal = productItem.itemNetAmountWithAllocateDiscountTotal;
    baseTransactionItem.itemNetAmountWithAllocateDiscountForAllocation =
      productItem.itemNetAmountWithAllocateDiscountForAllocation;
    return baseTransactionItem;
  },
  ConvertToSummaryAndCurrency(transaction) {
    let summary = transactionItemHelper.GetTransactionSummary(transaction);
    let SummaryAndCurrency = {
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          summary.transactionSummary.vatExemptedTotal.ToNumber() +
          summary.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: summary.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
    };
    return SummaryAndCurrency;
  },
  ConvertQuotationToTransactionCreate(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        toCurrencyCode: transaction.transactionCurrency.toCurrencyCode,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
        transaction.allocationTransactionList
      ),
      transactionItemType: transaction.transactionItemType,
    };

    let transactionListForCalculateAllocateDiscountPercent = transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      transaction.taxStatus,
      transaction.transactionItemList
    );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          id: transactionItem.id,
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.productTemplateId > 0 ? transactionItem.code : "",
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          fixAssetTemplateId: transactionItem.assetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: transactionItemHelper.GetAllocationListWithOutZeroPercent(
            transactionItem.allocationTransactionList
          ),
          isAcquisitionCost: transactionItem.isAcquisitionCost,
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = transactionHelper.AllocationTransactionEquals(
            transactionEdit.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice = transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(
          transactionItem
        );
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  IsApprovedInvoice(transactionStatus) {
    return transactionStatus != Enums.QuotationStatus.Draft && transactionStatus != Enums.QuotationStatus.AwaitApproval;
  },
  IsApprovedQuotation(transactionStatus) {
    return transactionStatus != Enums.QuotationStatus.Draft && transactionStatus != Enums.QuotationStatus.AwaitApproval;
  },
  IsApprovedReceipt(transactionStatus) {
    return transactionStatus != Enums.ReceiptStatus.Draft && transactionStatus != Enums.ReceiptStatus.AwaitApproval;
  },
  IsApprovedTaxInvoice(transactionStatus) {
    return (
      transactionStatus != Enums.TaxInvoiceStatus.Draft && transactionStatus != Enums.TaxInvoiceStatus.AwaitApproval
    );
  },
  IsApprovedCreditNote(transactionStatus) {
    return (
      transactionStatus != Enums.CreditNoteStatus.Draft && transactionStatus != Enums.CreditNoteStatus.AwaitApproval
    );
  },
  IsApprovedBillingNote(transactionStatus) {
    return (
      transactionStatus != Enums.BillingNoteStatus.Draft && transactionStatus != Enums.BillingNoteStatus.AwaitApproval
    );
  },
  IsApprovedDebitNote(transactionStatus) {
    return transactionStatus != Enums.DebitNoteStatus.Draft && transactionStatus != Enums.DebitNoteStatus.AwaitApproval;
  },
  GetExpenseTypeForGetSuggestionTransactionNumber(_transaction) {
    return GetExpenseTypeForGetSuggestionTransactionNumber(_transaction);
  },
  Base64ToBlob(base64, fileType) {
    const binaryString = atob(base64.split(",")[1]);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: fileType });
  },
};
